import { theme } from '~/theme';

export const useSxStyles = () => {
  return {
    avatar: {
      width: 64,
      height: 64,
      marginRight: theme.spacing(2),
    },
  };
};
